import { render, staticRenderFns } from "./jun_group.vue?vue&type=template&id=7e835242&scoped=true&v-once=true"
import script from "./jun_group.vue?vue&type=script&lang=js"
export * from "./jun_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e835242",
  null
  
)

export default component.exports